import styled from 'styled-components'

export const StyledTitle = styled.p`
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  letter-spacing: 0.15px;
  color: #333;
  margin: 0 0 12px 0;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    font-size: 16px;
    margin: 0 0 16px 0;
    line-height: 24px;
  }

  &:visited {
    color: #333;
  }
`

export const StyledDetailsText = styled.p`
  color: #282832;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 165%;
  margin: 0;
`

export const StyledDetailsPNotes = styled.p`
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 165%;
  margin: 5px 0;
`

export const StyledViewMoreBtn = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-left: 2px;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
  white-space: nowrap;
`
